import { useModalTrackingViewStyles } from "./modal-tracking-view.styles";
import { TrackingCheckpointItemType } from "@/schemas/index";
import { Flex, Row, Col, Text, Button, Steps } from "@/base/components/index";
import { LocalizationDatetime } from "@/app/index";
import { useContextModalTrackingView } from "../context/modal-tracking-view-context";
import { ProductImage } from "@/components/product-image/index";
import env from "@/app/config/env";

export const ModalTrackingViewContent = () => {
  const { styles } = useModalTrackingViewStyles();
  const { trackingData } = useContextModalTrackingView();

  const sortCheckpoints = (
    a: TrackingCheckpointItemType,
    b: TrackingCheckpointItemType,
  ) => {
    return (
      (b.checkpoint_time?.getTime() || 0) - (a.checkpoint_time?.getTime() || 0)
    );
  };

  if (!trackingData) {
    return null;
  }

  return (
    <Flex gap={12} vertical className={styles.content}>
      <Flex>
        <Row gutter={[24, 24]} align={"middle"}>
          <Col flex="none">
            <ProductImage
              width={160}
              height={160}
              className={styles.contentImage}
              src={`${env.hosts.image}/images/couriers/${trackingData?.slug}.png`}
            />
          </Col>
          <Col flex={1}>
            <Flex gap={8} style={{ width: "100%" }} vertical>
              {trackingData?.tag && (
                <Row gutter={[4, 4]}>
                  <Col flex="none">
                    <Text strong>Status:</Text>
                  </Col>
                  <Col flex={1}>
                    <Text>{trackingData?.tag}</Text>
                  </Col>
                </Row>
              )}

              {trackingData?.shipment_type && (
                <Row gutter={[8, 8]}>
                  <Col flex="none">
                    <Text strong>Shipment Type:</Text>
                  </Col>
                  <Col flex={1}>
                    <Text>{trackingData?.shipment_type}</Text>
                  </Col>
                </Row>
              )}

              {trackingData?.shipment_weight && (
                <Row gutter={[8, 8]}>
                  <Col flex="none">
                    <Text strong>Weight:</Text>
                  </Col>
                  <Col flex={1}>
                    <Text>
                      {trackingData?.shipment_weight.value}
                      {trackingData?.shipment_weight.unit}
                    </Text>
                  </Col>
                </Row>
              )}

              <Row gutter={[8, 8]}>
                <Col flex="none">
                  <Text strong>Courier Tracking Link:</Text>
                </Col>
                <Col flex={1}>
                  <Button
                    size="large"
                    variant="text"
                    color="primary"
                    target="_blank"
                    href={trackingData?.courier_tracking_link}
                  >
                    {trackingData?.tracking_number}
                  </Button>
                </Col>
              </Row>
            </Flex>
          </Col>
        </Row>
      </Flex>

      <Steps
        progressDot
        direction="vertical"
        items={trackingData.checkpoints
          .sort(sortCheckpoints)
          .map((checkpoint) => ({
            title: <Text>{checkpoint.message}</Text>,
            description: checkpoint.checkpoint_time && (
              <Text>
                <LocalizationDatetime value={checkpoint.checkpoint_time} />
              </Text>
            ),
            status: "process",
          }))}
      />
    </Flex>
  );
};
